import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { GeneralServiceService } from 'src/app/services/general-service.service';

@Component({
  selector: 'app-address-dialog',
  templateUrl: './address-dialog.component.html',
  styleUrls: ['./address-dialog.component.scss']
})
export class AddressDialogComponent implements OnInit {

 

  indirizzoFatturazione: {
    func: string,
    idut: any,
    token: any,
    ragsoc: any,
    indirizzo: any,
    localita: any,
    provincia: any,
    cap: any,
    telefono: any,
    email: any,
  } = {
    func: "",
    idut: "",
    token: "",
    ragsoc: "",
    indirizzo: "",
    localita: "",
    provincia: "",
    cap: "",
    telefono: "",
    email: "",
  }
  constructor(private genericFunc: GeneralServiceService, public dialogRef: MatDialogRef<AddressDialogComponent>) { }

  ngOnInit(): void {
  }

  salvaIndirizzo() {
    this.indirizzoFatturazione.func = 'aggIndSpedizione';
    this.indirizzoFatturazione.token = this.genericFunc.currentToken;
    this.indirizzoFatturazione.idut = this.genericFunc.currentUser.idut;

    this.genericFunc.genericFunction(this.indirizzoFatturazione).subscribe(response => {
      console.log(response);
      this.dialogRef.close({event:'newAddress',data:response.idSpedNew})
    });
  }

  closeDialog(){
    this.dialogRef.close({event:'Cancel'});
  }

}
